/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { Input } from '@arco-design/web-react';
import { useState } from 'react';
import AvatarCard from '@/components/AvatarCard';
import Utils from '@/utils/utils';
import InvokeButton from '@/pages/MainPage/MainArea/Antechamber/InvokeButton';
import { useJoin } from '@/lib/useCommon';
import style from './index.module.less';

function Antechamber() {
  const [joining, dispatchJoin] = useJoin();
  const [deviceId, setDeviceId] = useState(sessionStorage.getItem('deviceId') || '');
  const [figure, setFigure] = useState(sessionStorage.getItem('figure') || '');

  const handleJoinRoom = () => {
    if (!joining && deviceId && figure) {
      sessionStorage.setItem('deviceId', deviceId);
      sessionStorage.setItem('figure', figure);
      dispatchJoin({ deviceId, figures: [figure] }, false);
    }
  };

  return (
    <div className={style.wrapper}>
      <AvatarCard className={`${style.avatar} ${Utils.isMobile() ? style.mobile : ''}`} />
      <div className={style['input-box']}>
        <Input
          value={deviceId}
          onChange={(val) => {
            setDeviceId(val);
          }}
          placeholder="设备id"
        />
        <Input
          value={figure}
          onChange={(val) => {
            setFigure(val);
          }}
          placeholder="玩偶id"
        />
      </div>
      <InvokeButton onClick={handleJoinRoom} loading={joining} className={style['invoke-btn']} />
    </div>
  );
}

export default Antechamber;
